import {Component, OnInit, Input, HostListener} from '@angular/core';
import {MatLegacyDialogRef as MatDialogRef} from '@angular/material/legacy-dialog';
import {Router} from '@angular/router';

@Component({
    selector: 'ngc-confirm-dialog',
    templateUrl: './notification-dialog.component.html',
    styleUrls: ['./notification-dialog.component.scss']
})
export class NotificationDialogComponent implements OnInit {

    @Input() header = 'Are you sure?';
    @Input() target = '';
    @Input() notificationLink: string;

    @HostListener('document:keydown.enter', ['$event'])
    onEnterKeydownHandler(event: KeyboardEvent) {
        this.onSubmit();
        event.preventDefault();
    }
    @HostListener('document:keydown.escape', ['$event'])
    onEscapeKeydownHandler(event: KeyboardEvent) {
        this.onCancel();
    }

    constructor(public dialogRef: MatDialogRef<NotificationDialogComponent>,
                private router: Router) {
    }

    ngOnInit() {
    }

    goToLink() {
        this.router.navigate([this.notificationLink]);
    }

    onSubmit(result = '') {
        this.goToLink();
        this.close(result);
    }

    private close(result: string) {
        this.dialogRef.close(result);
    }

    onCancel(result = '') {
        this.close(result);
    }
}
